import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBooking, setStep } from "../../../Reducer/bookingSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import White from "../../../Assets/images/white-bg.avif"
import Compressor from 'compressorjs';
import { toast } from "react-toastify";
import { useAuth } from "../../../Contexts/AuthenticateProvider"
import Handler from "../../../Helpers/Components/Handler";
import Select from 'react-select'

const Pending = (props) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state?.booking?.booking)
    const setSteps = () => {
        dispatch(setStep(3))
    }
    const handleNext = async () => {
        if (!booking?.comment) return toast.error("Comment is required")
        setLoading(true)
        const response = await Handler({ method: 'patch', data: { comment: booking?.comment }, url: `/booking/close/fifth/update/${props?.bookingId}` })
        setLoading(false)
        if (response?.success) {
            dispatch(setStep(5))
        } else {
            toast.error(response?.message);
        }
    }
    const checkFileSize = async (file) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            const value = Array.isArray(booking?.pendingPhoto) ? booking.pendingPhoto : [];
            const updatedValue = [...value, { url: URL.createObjectURL(file), file: file }];
            dispatch(setBooking({ pendingPhoto: updatedValue }));
        }
    };
    const compressImage = (file) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0]);
        }
    };

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="leadMode" className="form-label"> Lead Mode </label>
                        <input name="leadMode" id="leadMode" autoComplete="off" readOnly disabled className="form-control input-theme text-uppercase" value={booking?.lead?.mode || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="leadTakenBy" className="form-label"> Lead Attended By </label>
                        <input readOnly name="leadTakenBy" id="leadTakenBy" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.lead?.name || booking?.lead?.staffId || ""} />
                    </div>
                </div>
                {/* <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="closedBy" className="form-label"> Booking Closed By </label>
                        <Select
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            onChange={(e) => { dispatch(setBooking({ pickupBy: e.value })) }} value={props?.leadList?.length && booking.pickupBy ? (props?.leadList?.find(element => element.value === booking?.pickupBy) || "") : ""} options={props.leadList} />

                    </div>
                </div> */}
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="comment" className="form-label"> Comment </label>
                        <input name="comment" id="comment" autoComplete="off" onChange={(e) => dispatch(setBooking({ comment: e.target.value }))} disabled={loading} className="form-control input-theme text-uppercase" value={booking?.comment || ""} />
                    </div>
                </div>
            </div>
            <NextPrev step={4} setStep={setSteps} last={4} onClick={handleNext} loading={false} />
        </React.Fragment>
    )
}

export default Pending;
